/* eslint-disable react/prop-types */
import ContentLoader from "react-content-loader";

const BillingCardLoader = () => {
  const agencyInfo = JSON.parse(localStorage.getItem("agencyInfo") || "{}");
  const layoutTheme = agencyInfo.data?.layout_theme || "light";

  return (
    <div className="card shadow-sm" style={{ marginBottom: "0px" }}>
      <div className="card-header d-flex justify-content-between align-items-center bg-light">
        <ContentLoader
          speed={2}
          width={200}
          height={25}
          viewBox="0 0 200 25"
          backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
          foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
        >
          {/* Header title */}
          <rect x="0" y="5" rx="4" ry="4" width="180" height="15" />
        </ContentLoader>
        <ContentLoader
          speed={2}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
          foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
        >
          {/* Edit icon */}
          <rect x="0" y="0" rx="2" ry="2" width="20" height="20" />
        </ContentLoader>
      </div>
      <div className="card-body">
        <div className="row">
          {/* First Name */}
          <div className="col col-billing d-grid mb-3">
            <ContentLoader
              speed={2}
              width={150}
              height={60}
              viewBox="0 0 150 60"
              backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
              foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
            >
              <rect x="0" y="0" rx="3" ry="3" width="80" height="12" />
              <rect x="0" y="25" rx="3" ry="3" width="120" height="16" />
            </ContentLoader>
          </div>
          
          {/* Last Name */}
          <div className="col col-billing d-grid mb-3">
            <ContentLoader
              speed={2}
              width={150}
              height={60}
              viewBox="0 0 150 60"
              backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
              foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
            >
              <rect x="0" y="0" rx="3" ry="3" width="75" height="12" />
              <rect x="0" y="25" rx="3" ry="3" width="110" height="16" />
            </ContentLoader>
          </div>
          
          {/* Email */}
          <div className="col col-billing d-grid mb-3">
            <ContentLoader
              speed={2}
              width={200}
              height={60}
              viewBox="0 0 200 60"
              backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
              foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
            >
              <rect x="0" y="0" rx="3" ry="3" width="40" height="12" />
              <rect x="0" y="25" rx="3" ry="3" width="150" height="16" />
            </ContentLoader>
          </div>
          
          {/* Phone */}
          <div className="col col-billing d-grid mb-3">
            <ContentLoader
              speed={2}
              width={150}
              height={60}
              viewBox="0 0 150 60"
              backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
              foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
            >
              <rect x="0" y="0" rx="3" ry="3" width="50" height="12" />
              <rect x="0" y="25" rx="3" ry="3" width="130" height="16" />
            </ContentLoader>
          </div>
          
          {/* Title */}
          <div className="col col-billing d-grid mb-3">
            <ContentLoader
              speed={2}
              width={150}
              height={60}
              viewBox="0 0 150 60"
              backgroundColor={layoutTheme === "light" ? "#f3f3f3" : "var(--bs-header-bg)"}
              foregroundColor={layoutTheme === "light" ? "#ecebeb" : "var(--bs-white)"}
            >
              <rect x="0" y="0" rx="3" ry="3" width="35" height="12" />
              <rect x="0" y="25" rx="3" ry="3" width="100" height="16" />
            </ContentLoader>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingCardLoader;
